import React, { useState } from 'react';
import DraggableSlider from './DraggableSlider';
import { getService } from '@Shared.Angular/flowingly.hooks/useService';

type DraggableSliderContainerProps = {
  min: number;
  max: number;
  value: number;
  onChange: (val: number) => void;
  step?: number;
};

const DraggableSliderContainer = ({
  min,
  max,
  value,
  onChange,
  step = 10
}: DraggableSliderContainerProps) => {
  const [isMobile] = useState<boolean>(
    getService('browserUtilsService').isMobileDevice()
  );
  max *= isMobile ? 2 : 1;
  step *= isMobile ? 2 : 1;
  return (
    <div className={'draggable-slider-container' + (isMobile ? ' mobile' : '')}>
      <i
        className="fas fa-minus"
        onClick={() => onChange(Math.max(min, value - step))}
      ></i>
      <DraggableSlider
        min={min}
        max={max}
        value={value}
        onChange={onChange}
      ></DraggableSlider>
      <i
        className="fas fa-plus"
        onClick={() => onChange(Math.min(max, value + step))}
      ></i>
      <span className="zoom-value">{value}%</span>
    </div>
  );
};

export default DraggableSliderContainer;
